import React from 'react';
import { Box, useDisclosure } from '@chakra-ui/core';
import Header from '../../Header';
import MainNav from '../../MainNav';

export const PrivateLayout = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box minHeight="100vh" d="flex" flexDirection="column" bg="lightGray3">
      <Header onMenuOpen={onOpen} />
      <Box d="flex" flexGrow="1" position="relative">
        <MainNav isOpen={isOpen} onClose={onClose} />
        <Box
          as="main"
          data-testid="private-layout-main"
          d="flex"
          flexDirection="column"
          flexGrow="1"
          ml={0}
          minW="0"
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
